import { routerShape } from 'react-router';
import { setBackTo } from '@bibliocommons/utils-rails';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import isEqual from 'lodash/isEqual';

/**
 * This is a list of url patterns to ignore when updating the rails "back to" link.
 * We shouldn't need to add anything to this. Pages can opt out of updating backTo links
 * by not defining getBackToTitleKey().
 */
const BACK_TO_BLACKLIST = ['/availability/'];

const shouldUpdateBackTo = (url) => {
  const matchedItems = BACK_TO_BLACKLIST.filter(
    blacklistedItem => url.indexOf(blacklistedItem) !== -1
  );

  return matchedItems.length === 0;
};

/**
 * This is a base class for page-level containers (containers that correspond to routes).
 *
 * If you extend this class and override react life cycle methods like
 * componentDidMount remember to call super.componentDidMount(), etc.
 */
class BasePageContainer extends BcReactComponent {
  updateBackTo(url) {
    const getBackToTitleKey = this.getBackToTitleKey ? this.getBackToTitleKey.bind(this) : this.constructor.getBackToTitleKey;
    const title = getBackToTitleKey && getBackToTitleKey();
    if (title && url && shouldUpdateBackTo(url)) {
      setBackTo({ title, url });
    }
  }

  componentDidMount() {
    this.updateBackTo(window.location.href);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;

    if (!isEqual(location, prevProps.location)) {
      this.updateBackTo(window.location.href);
    }
  }
}

BasePageContainer.propTypes = {
  router: routerShape
};

export default BasePageContainer;



// WEBPACK FOOTER //
// ./app/containers/BasePageContainer.jsx